/* eslint-disable import/first */
import * as React from 'react'
import { useMutation } from 'react-query'

import { getFormattedDateString } from '../../../header/utils'
import { Share as ShareDialog } from '../../../shared/components/Share'
import { drawShareMap } from '../../../shared/drawShareMap'
import * as api from '../../services/api'
import mapStore from '../../store/mapStore'
import Treemap from '../../treemap'
import { MapSubtype, MapType } from '../../types'

interface ShareMapProps {
  treemap: Treemap
  mapType: MapType
  subtype: MapSubtype
  className?: string
}

export function Share(props: ShareMapProps) {
  const uploadImage = useMutation(api.uploadMap)

  const onShareClick = React.useCallback(async () => {
    const canvas = mapStore.getPublishCanvas()
    const data = await drawShareMap(canvas, [props.mapType.name, props.subtype.name, getFormattedDateString()])

    if (data) {
      uploadImage.mutate({ type: props.treemap.type, subtype: props.treemap.subtype, data })
    }
  }, [props.mapType, props.subtype, props.treemap, uploadImage])

  return <ShareDialog className={props.className} onShareClick={onShareClick} state={uploadImage} />
}
